import AssetTable from './AssetTable';

export { DuplicateAssetNestedRenderer } from './DuplicateAssetNestedRenderer';

export default AssetTable;
